import React, { useState } from 'react';
import cn from 'classnames';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
// Styles
import styles from './DropdownItem.module.scss';

type DropdownItemProps = {
  label: string;
  children: React.ReactNode;
  defaultExpanded?: boolean;
  className?: string;
  labelClassName?: string;
};

const DropdownItem: React.FC<DropdownItemProps> = ({
  label,
  children,
  defaultExpanded = false,
  className,
  labelClassName,
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={cn(styles.root, className)}>
      <button
        className={cn(styles.label, labelClassName)}
        onClick={toggleExpanded}
      >
        <span>{label}</span>
        {isExpanded ? <UpOutlined /> : <DownOutlined />}
      </button>
      {isExpanded && <div className={styles.content}>{children}</div>}
    </div>
  );
};

export default DropdownItem;
